export default __webpack_public_path__ + "static/media/landmark reward.1b9e4006.svg";